import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@zocdoc/components/src/button';
import styled from 'styled-components';
import { breakpoint } from '@zocdoc/components/src/grid';
import { LOCALIZED_STRINGS } from '../BookingSection/constants';
import { FormattedMessage } from 'react-intl';
import { sharpSansBold } from '@zocdoc/components/src/typography';
import NextAvailability from '../NextAvailability';

export default class BookingSection extends PureComponent {
    static propTypes = {
        turnBookingSpotlightOn: PropTypes.func.isRequired,
    }

    turnBookingSpotlightOn = () => this.props.turnBookingSpotlightOn();

    bypassClickEvent = ev => ev.stopPropagation();

    render() {
        return (
            <div
                data-test="show-booking-section-component-area"
                onClick={this.turnBookingSpotlightOn}
                role="presentation"
            >
                <TranslucentBackground onClick={this.bypassClickEvent} />
                <BookButton
                    data-test="show-booking-section-component-button"
                    data-uem-id="book-appointment"
                    style={Button.STYLE.INVERTED}
                >
                    <FormattedMessage {...LOCALIZED_STRINGS.BookingSectionButtonText} />
                </BookButton>
                <NextAvailability
                    alternate={<TranslucentBackground />}
                    provider={this.props.provider}
                />
                <AdditionalSpaceForBranchPill />
            </div>
        );
    }
}

const TranslucentBackground = styled.div`
    display: block;
    height: 20px;
    opacity: 0;

    ${breakpoint.medium} {
        display: none !important;
    }
`;

const BookButton = styled(Button)`
    ${sharpSansBold(18, 28)}
    display: block;
    text-align: center;
    width: calc(100% - 32px);
    margin: 0 16px;
    letter-spacing: 0.5px;
    height: 44px;

    ${breakpoint.small} {
        height: 48px;
    }

    ${breakpoint.medium} {
        display: none !important;
    }
`;

const AdditionalSpaceForBranchPill = styled.div`
    transition: height .25s ease;
    height: 0px;

    .branch-banner-is-active & {
        height: 52px;
    }
`;
